module.exports = __webpack_public_path__ + "img/galery-inge-v9-3-zoom.c69434ef.jpg";